"use client";

import dynamic from 'next/dynamic'
import { CreatePool } from '@/components/create-pool'
import { PoolList } from '@/components/pool-list'
import { CurrentBlock } from '@/components/current-block'
import { ContractOwner } from '@/components/contract-owner'
import { WalletReminderBot } from '@/components/wallet-reminder-bot'

// Dynamic import with no SSR to prevent hydration issues
const WalletConnect = dynamic(() => import('@/components/wallet-connect').then(mod => ({ default: mod.WalletConnect })), {
  ssr: false,
  loading: () => (
    <div className="bg-black border border-green-700/30 rounded-lg p-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-mono text-green-600 mb-2">🔗 Wallet Connection</h2>
          <p className="text-sm text-green-700/80 font-mono">
            Loading wallet interface...
          </p>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 border-2 border-green-400 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-green-600 font-mono text-sm">
            Loading...
          </span>
        </div>
      </div>
    </div>
  )
})

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">MultitierStaking dApp</h1>
          <p className="text-muted-foreground text-lg mb-4">
            Stake your AMIRA tokens and earn rewards with our multi-tier staking system
          </p>
          <div className="inline-flex items-center gap-2 bg-emerald-100 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 px-3 py-1 rounded-full text-sm">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
            Base Sepolia Network
          </div>
        </div>

        <div className="grid gap-6">
          {/* Wallet Connection */}
          <WalletConnect />

          {/* Current Block Info */}
          <CurrentBlock />

          {/* Contract Owner */}
          <ContractOwner />

          {/* Pool List with integrated actions */}
          <PoolList />

          {/* Create Pool - Keep for owner functionality */}
          <div className="max-w-2xl mx-auto">
            <CreatePool />
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="bg-muted/50 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="font-medium mb-3">Contract Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-muted-foreground mb-1">Staking Contract:</p>
                <code className="bg-background px-2 py-1 rounded text-xs break-all">
                  {process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || 'Not configured'}
                </code>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">AMIRA Token:</p>
                <code className="bg-background px-2 py-1 rounded text-xs break-all">
                  {process.env.NEXT_PUBLIC_STAKE_TOKEN_ADDRESS || 'Not configured'}
                </code>
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-4">
              🔐 Deployed on Base Sepolia Testnet • Always verify contract addresses before transacting
            </p>
          </div>
        </div>
      </div>
      
      {/* Wallet Reminder Bot */}
      <WalletReminderBot />
    </div>
  )
}
